import { PlaceService, PlaceType, ScoredPlace } from "@gen/place/v1/place_pb";
import { client } from "./config";
import { DAP, Transportation } from "@gen/dap/v1/dap_pb";

export async function search(
  query: string,
  types: PlaceType[] = [],
): Promise<ScoredPlace[]> {
  const res = await client(PlaceService).search({
    query,
    filters: {
      types,
    },
  });
  return res.places;
}

export async function near(dap: DAP): Promise<ScoredPlace[]> {
  const res = await client(PlaceService).near({
    dapNumber: dap.number,
    latitude: dap.origin?.latitude,
    longitude: dap.origin?.longitude,
    types: dap.transportations.reduce((acc, t) => {
      switch (t) {
        case Transportation.TRAIN:
          return [...acc, PlaceType.TRAIN_STATION];
        case Transportation.PLANE:
          return [...acc, PlaceType.AIRPORT];
        default:
          return acc;
      }
    }, [] as PlaceType[]),
  });
  return res.places;
}
